import { useTranslation } from 'react-i18next'

import {
  EMPTY_STRING,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { useScreen } from '../../../hooks'
import { Checkbox, CHECKBOX_TYPE } from '../../Checkbox'
import { ButtonSelect, ButtonTextSelectControl } from '../../Select'
import { Skeleton } from '../../Skeleton'
import Text from '../../Text'
import { getIsHiddenTableControlBarText } from '../Table.utils'

import {
  MASS_ACTION_DROPDOWN_MAX_HEIGHT,
  QA_NAME_MASS_ACTION,
  QA_NAME_MASS_ACTION_MENU,
} from './TableMassAction.constants'
import { getMassActionsWithDivider } from './TableMassAction.utils'

import * as styles from './TableMassAction.module.css'

function TableMassAction({
  actions,
  allowSelectionWithoutActions = false,
  containerRef,
  disabled,
  getIsHiddenTableText = getIsHiddenTableControlBarText,
  isAllSelected,
  isLoading,
  isRemoveSelection,
  responsive,
  selectedSize,
  setMassAction,
  onSelectAll,
}) {
  const { t } = useTranslation()

  const { width: screenWidth } = useScreen({ containerRef })

  function handleCallAction(action) {
    setMassAction(action.value)
  }

  const massActionsWithDivider = getMassActionsWithDivider(actions)

  const isMobileScreenSize = getIsHiddenTableText({
    responsive,
    screenWidth,
  })

  return (
    <div className={styles.tableMassAction}>
      {isLoading ? (
        <Skeleton className={styles.skeleton} />
      ) : (
        <>
          <Checkbox
            checked={isAllSelected}
            disabled={
              (disabled ?? actions.length === 0) &&
              !allowSelectionWithoutActions
            }
            qaName={QA_NAME_MASS_ACTION}
            selected={isRemoveSelection}
            size='small'
            type={CHECKBOX_TYPE.table}
            onChange={onSelectAll}
          />
          {selectedSize && actions.length > 0 ? (
            <ButtonSelect
              Control={ButtonTextSelectControl}
              className={styles.actionsButton}
              controlProps={{
                buttonProps: {
                  className: styles.actionsText,
                  qaName: QA_NAME_MASS_ACTION_MENU,
                  text: isMobileScreenSize
                    ? EMPTY_STRING
                    : t('Table.ActionsBtnKey'),
                },
              }}
              dropdownFloatingConfig={{
                dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
                dropdownStyles: {
                  maxHeight: MASS_ACTION_DROPDOWN_MAX_HEIGHT,
                },
                maxWidthByRef: false,
              }}
              dropdownProps={{
                className: styles.dropdown,
              }}
              filter={null}
              listProps={{
                headerProps: {
                  Search: null,
                },
                itemProps: {
                  contentProps: {
                    infoProps: {
                      contentTextProps: {
                        textProps: {
                          isSecondary: true,
                        },
                      },
                    },
                  },
                },
              }}
              options={massActionsWithDivider}
              onSelectItem={handleCallAction}
            />
          ) : (
            <Text
              isSecondary
              className={styles.text}
              disabled={actions.length === 0 && !allowSelectionWithoutActions}
            >
              {isMobileScreenSize
                ? EMPTY_STRING
                : t('Table.MassSelectionLabelKey')}
            </Text>
          )}
        </>
      )}
    </div>
  )
}

export default TableMassAction
